import { Button, DatePicker } from "antd-mobile";
import dayjs from "dayjs";
import { t } from "i18next";
import { useEffect, useState } from "react";
import styles from "./style.module.scss";

const FilterTypeDateTimeRange = ({
  precision = "second", //second / minute / hour / day / month / year
  title = "",
  startDate = null,
  endDate = null,
  setStartDateValue = () => {},
  setEndDateValue = () => {},
  maxMonthInterval,
}) => {
  const formatTemplate = {
    second: "YYYY-MM-DD HH:mm:ss",
    day: "YYYY-MM-DD",
    month: "YYYY-MM",
  };

  const currentDate = new Date();
  const [dateStartPickerVisible, setDateStartPickerVisible] = useState(false);
  const [dateEndPickerVisible, setDateEndPickerVisible] = useState(false);
  const [minDate, setMinDate] = useState(
    new Date(currentDate.setFullYear(currentDate.getFullYear() - 10)),
  );
  const [maxDate, setMaxDate] = useState(
    new Date(currentDate.setFullYear(currentDate.getFullYear() + 10)),
  );
  const [endMaxDate, setEndMaxDate] = useState(
    new Date(currentDate.setFullYear(currentDate.getFullYear() + 10)),
  );

  const onOpenStartDatePicker = () => {
    setDateStartPickerVisible(true);
  };

  const onOpenEndDatePicker = () => {
    setDateEndPickerVisible(true);
  };

  const closeDateStartPicker = () => {
    setDateStartPickerVisible(false);
  };

  const closeDateEndPicker = () => {
    setDateEndPickerVisible(false);
  };

  const confirmDateStartPicker = (val) => {
    setMinDate(new Date(dayjs(val)));
    if (maxMonthInterval) {
      const max = new Date(dayjs(val)).setMonth(
        new Date(dayjs(val)).getMonth() + parseInt(maxMonthInterval),
      );
      setEndMaxDate(new Date(max));
    }
    setStartDateValue(dayjs(val).format(formatTemplate[precision]));
    setDateStartPickerVisible(false);
    setDateEndPickerVisible(true);
  };

  const confirmDateEndPicker = (val) => {
    // setMinDate(new Date(dayjs(val)));
    setEndDateValue(dayjs(val).format(formatTemplate[precision]));
    setDateEndPickerVisible(false);
  };

  useEffect(() => {
    const start = new Date(startDate);
    setMinDate(start);
    if (maxMonthInterval) {
      const start = new Date(startDate);
      setEndMaxDate(new Date(start.setMonth(start.getMonth() + parseInt(maxMonthInterval))));
    }
  }, [maxMonthInterval, startDate]);

  return (
    <div className={`${styles.container}`}>
      <div className={`${styles.title}`}>{title}</div>
      <div className={`${styles.dateContainer}`}>
        <Button className={`${styles.dateButton}`} onClick={onOpenStartDatePicker}>
          {startDate === null
            ? t("mobile.normal.dateFrom")
            : dayjs(startDate).format(formatTemplate[precision])}
        </Button>
        <div className={`${styles.to}`}>{t("normal.to")}</div>
        <Button className={`${styles.dateButton}`} onClick={onOpenEndDatePicker}>
          {endDate === null
            ? t("mobile.normal.dateTo")
            : dayjs(endDate).format(formatTemplate[precision])}
        </Button>
      </div>
      <DatePicker
        confirmText={t("normal.confirm")}
        cancelText={t("normal.cancel")}
        key="date-start-picker"
        precision={precision}
        onClose={closeDateStartPicker}
        closeOnMaskClick={false}
        // cancelText=""
        onConfirm={confirmDateStartPicker}
        onCancel={closeDateStartPicker}
        visible={dateStartPickerVisible}
        max={maxDate}
      />
      <DatePicker
        confirmText={t("normal.confirm")}
        cancelText={t("normal.cancel")}
        key="date-end-picker"
        precision={precision}
        onClose={closeDateEndPicker}
        closeOnMaskClick={false}
        // cancelText=""
        onCancel={closeDateEndPicker}
        onConfirm={confirmDateEndPicker}
        visible={dateEndPickerVisible}
        min={minDate}
        max={endMaxDate}
      />
    </div>
  );
};

export default FilterTypeDateTimeRange;
